<template>
    <div>
        <div class="container">
            TotalAvailableMemoryBytes: {{modelSystemStatsQueryV1.TotalAvailableMemoryBytes}}<br />
            WorkingSet64: {{modelSystemStatsQueryV1.WorkingSet64}}<br />
            TotalMemory: {{modelSystemStatsQueryV1.TotalMemory}}<br />
            TotalAllocatedMemory: {{modelSystemStatsQueryV1.TotalAllocatedMemory}}<br />
            Gen0Collections: {{modelSystemStatsQueryV1.Gen0Collections}}<br />
            Gen1Collections: {{modelSystemStatsQueryV1.Gen1Collections}}<br />
            Gen2Collections: {{modelSystemStatsQueryV1.Gen2Collections}}<br />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted } from 'vue'
    import { useSystemStatsQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'

    const { modelSystemStatsQueryV1, runSystemStatsQueryV1 } = useSystemStatsQueryV1()

    onMounted(() => runSystemStatsQueryV1())
</script>
